<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       data-url="hkiarace/admin/company/"
                       data-key="companies"
                       :extra-params="{with_disabled: true}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.disabled="{value}">
      <v-icon v-if="value">mdi-lock
      </v-icon>
    </template>
    <template v-slot:item.actions="{item}">
      <v-row>
        <v-col>
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="editItem(item)">
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
<!--          <font-awesome-icon icon="edit"-->
<!--                             @click="editItem(item)"></font-awesome-icon>-->
        </v-col>
        <v-col v-if="!item.disabled">
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="disableItem(item)">
                <v-icon>mdi-lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('disable') }}</span>
          </v-tooltip>
<!--          <font-awesome-icon icon="lock"-->
<!--                             @click="disableItem(item)"></font-awesome-icon>-->
        </v-col>
        <v-col v-if="item.disabled">
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="enableItem(item)">
                <v-icon>mdi-lock-open</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('enable') }}</span>
          </v-tooltip>
<!--          <font-awesome-icon icon="unlock"-->
<!--                             @click="enableItem(item)"></font-awesome-icon>-->
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'CompanyList',
  components: {RemotePaginatedList},
  props: {
    hideSearch: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_company.name_en'), value: 'name_en', contains: true},
        {text: root.$t('admin_company.name_zh'), value: 'name_zh', contains: true},
        {
          text: root.$t('admin_company.disabled'), value: 'disabled',
          options: [
            {text: root.$t('yes'), value: true},
            {text: root.$t('no'), value: false},
          ],
        },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_company.name_en'), value: 'name_en'},
      {text: root.$t('admin_company.name_zh'), value: 'name_zh'},
      {text: root.$t('admin_company.disabled'), value: 'disabled'},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    const editItem = function (item) {
      emit('edit', item);
    };

    const disableItem = function (item) {
      root.$callAPI('hkiarace/admin/company/disable/', {id: item.id}, function () {
        refresh();
      })
    }

    const enableItem = function (item) {
      root.$callAPI('hkiarace/admin/company/enable/', {id: item.id}, function () {
        refresh();
      })
    }


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      disableItem,
      enableItem,
    }
  }
}
</script>
